import { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { selectCurrentContactId } from 'ducks/crm/contacts'
import { selectAccountPreferenceSortByCollaboratorCommentEnabled } from 'selectors/app/selectAccountPreferences'

import { doFetchRecentConversationsAndRooms } from './operations'
import {
  selectIsOrWillBeLoadingRecentConversationsAndChatsForCurrentContact,
  selectRecentConversationsAndChatsForCurrentContact,
} from './selectors'

export function useRecentConversations() {
  const contactId = useSelector(selectCurrentContactId)
  // TODO: (convo-reordering-after-full-migrations): remove sortByCollaboratorCommentAtEnabled
  const sortByCollaboratorCommentAtEnabled = useSelector(
    selectAccountPreferenceSortByCollaboratorCommentEnabled
  )

  const dispatch = useDispatch()
  useEffect(
    () => {
      if (contactId)
        dispatch(
          doFetchRecentConversationsAndRooms(
            contactId,
            sortByCollaboratorCommentAtEnabled
          )
        )
    },
    [dispatch, contactId, sortByCollaboratorCommentAtEnabled]
  )
  const conversations = useSelector(
    selectRecentConversationsAndChatsForCurrentContact
  )
  return {
    isLoading: useSelector(
      selectIsOrWillBeLoadingRecentConversationsAndChatsForCurrentContact
    ),
    hasConversations: conversations?.length > 0,
    conversations,
  }
}
